export default __webpack_public_path__ + "static/media/video.d50ab0e2.mp4";